var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3606 14.5653H16.14C16.0447 14.5653 15.9653 14.6447 15.9653 14.74V16.142H1.67939V1.8538H15.9676V3.25585C15.9676 3.35114 16.047 3.43054 16.1423 3.43054H17.3629C17.4581 3.43054 17.5375 3.3534 17.5375 3.25585V0.982621C17.5375 0.596944 17.2267 0.286133 16.8411 0.286133H0.808213C0.422536 0.286133 0.111725 0.596944 0.111725 0.982621V17.0132C0.111725 17.3989 0.422536 17.7097 0.808213 17.7097H16.8388C17.2245 17.7097 17.5353 17.3989 17.5353 17.0132V14.74C17.5353 14.6424 17.4559 14.5653 17.3606 14.5653ZM17.7826 8.85498L14.5633 6.31405C14.4431 6.21876 14.2684 6.30497 14.2684 6.45698V8.18118H7.14467C7.04485 8.18118 6.96317 8.26285 6.96317 8.36268V9.63314C6.96317 9.73297 7.04485 9.81464 7.14467 9.81464H14.2684V11.5388C14.2684 11.6908 14.4453 11.7771 14.5633 11.6818L17.7826 9.14084C17.8043 9.12386 17.8218 9.10217 17.8339 9.0774C17.8459 9.05264 17.8522 9.02546 17.8522 8.99791C17.8522 8.97036 17.8459 8.94318 17.8339 8.91842C17.8218 8.89365 17.8043 8.87196 17.7826 8.85498Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/ExportIcon.64a35070e69a0970a41cbd3f3efe44ae.svg";
export { ForwardRef as ReactComponent };